import * as Sentry from "@sentry/react";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { getEnvironment, getEnvironmentVariable } from "./lib/environment.ts";
import { router } from "./router";
import "./styles/global.css";
import "./styles/sentry.css";

Sentry.init({
  dsn: "https://e4ac4568a0e52856a7d5f52eb9766fc9@o4508126817615872.ingest.us.sentry.io/4509797144723456",
  sendDefaultPii: true,
  environment: getEnvironment(),
  enabled: getEnvironment() !== "development",
  integrations: [
    Sentry.feedbackIntegration({
      colorScheme: "light",
      showBranding: false,
      triggerLabel: "Feedback",
      autoInject: false,
      themeLight: {
        accentBackground: "var(--color-accent-secondary)",
        accentForeground: "var(--color-accent-secondary-foreground)",
        foreground: "var(--color-foreground)",
      },
    }),
  ],
});

const domainName = getEnvironmentVariable("DOMAIN_NAME");

if (domainName !== window.location.hostname) {
  window.location.href = window.location.href
    .replace(window.location.hostname, domainName)
    .replace(":3000", "");
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <HelmetProvider>
      <RouterProvider router={router} />
    </HelmetProvider>
  </StrictMode>,
);
